// extracted by mini-css-extract-plugin
export var root = "A-oh";
export var rootHeading = "HevE";
export var rootItem = "XviW";
export var rootItemIcon = "zh4R";
export var rootItemRate = "Aeci";
export var rootItemText = "JtDe";
export var rootItems = "bGFt";